import CameraSVG from "@design-system/ui-icons/vanilla/Camera"
import { createIcon } from "../createIcon"

export const CameraIcon = createIcon(CameraSVG)
